import React from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import styled from "styled-components";
import FormButtons from "src/components/CreditRatingForm/FormButtons";
import { StepControls } from "src/components/CreditRatingStepWizard/CreditRatingStepWizard";
import { isNumber } from "src/utils/object";

const Root = styled("div")`
    text-align: center;
`;

const CreditScoreSection = styled("div")`
    color: ${(props) => props.theme.palette.grey[100]};
    margin-bottom: 24px;
`;

const CreditScoreText = styled("span")`
    font-size: 18px;
    font-weight: 500;
    margin-right: 5px;
`;

const CreditScore = styled("div")`
    display: inline-block;
    font-size: 26px;
    font-weight: 700;
    margin-bottom: 4px;
    vertical-align: middle;
`;

const Description = styled("div")`
    color: ${(props) => props.theme.palette.grey[80]};
    font-size: 14px;
    margin: 0 auto 24px;
    width: 75%;
`;

interface CreditRatingResultSuccessProps {
    description: string;
    CTA: string;
    lowScore: number | undefined;
    highScore: number | undefined;
}

const getScoreDisplay = (lowScore: number | undefined, highScore: number | undefined) => {
    return isNumber(lowScore) && isNumber(highScore) ? `${lowScore}-${highScore}` : "";
};

const CreditRatingResultSuccess = ({
    cancel,
    next,
    description,
    CTA,
    lowScore,
    highScore,
    t,
}: StepControls & CreditRatingResultSuccessProps & WithTranslation) => {
    return (
        <Root>
            <CreditScoreSection>
                <CreditScoreText>{t("CreditRatingResultSuccess.creditScoreText")}</CreditScoreText>
                <CreditScore>{getScoreDisplay(lowScore, highScore)}</CreditScore>
            </CreditScoreSection>
            <Description>{description}</Description>
            <FormButtons onCancel={cancel} onSubmit={next} continueText={CTA} />
        </Root>
    );
};

export default withTranslation()(CreditRatingResultSuccess);
